import React from "react";
const SpinnerCircle4: React.FC<{ style: React.CSSProperties }> = ({ style }) => (
    <div style={style} className="w-7 h-7 border-[3px] border-primary/10 border-t-primary border-b-primary rounded-full animate-spin" />
);
export default SpinnerCircle4;
